import { render, staticRenderFns } from "./AdminVerify.vue?vue&type=template&id=15083331&scoped=true&"
import script from "./AdminVerify.vue?vue&type=script&lang=js&"
export * from "./AdminVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15083331",
  null
  
)

export default component.exports